export default "__VITE_ASSET__DTL1FW5f__"